export const STATUS_CHANGE_DIALOG_DATA = {
  data: {
    title: 'Confirmação de troca de stauts!',
    message: 'Você deseja realmente trocar o status desse item?',
    icon: 'warning',
    iconColor: 'red',
    buttons: [
      {
        label: 'no',
        value: false,
        color: 'warn',
        icon: 'clear',
      },
      {
        label: 'yes',
        value: true,
        color: 'primary',
        icon: 'check',
      },
    ],
  },
  panelClass: 'mat-dialog-size',
};